import React from 'react';

export const BrandSymbol: React.FunctionComponent = () => {
  return (
    <svg width="29" height="38" viewBox="0 0 29 38" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1346 0.539938C15.6148 -0.625307 17.7869 0.193628 18.1568 2.05643L23.5776 29.3515C23.8147 30.5453 23.1895 31.7432 22.0827 32.2158L9.00808 37.7982C7.5796 38.4081 5.95152 37.5806 5.57862 36.055L0.0742442 13.5359C-0.16597 12.5531 0.187677 11.5192 0.976376 10.8983L14.1346 0.539938Z"
        fill="url(#paint0_linear_217_1903)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5445 36.8231L26.7883 35.2489C27.858 35.1114 28.626 34.1504 28.5243 33.0767L25.9316 5.69679C25.8083 4.39497 24.4894 3.5597 23.2599 4.00471L20.0615 5.16225L24.8154 29.0989C25.171 30.8896 24.2332 32.6864 22.573 33.3953L14.5445 36.8231ZM9.89094 37.4215L22.0832 32.2158C23.19 31.7432 23.8152 30.5453 23.5781 29.3515L18.8605 5.59694L14.2418 7.26853C12.8359 7.77737 12.9023 9.78796 14.3387 10.2029C14.7474 10.3209 15.0892 10.6024 15.2835 10.9807L15.7551 11.8992C16.343 13.044 15.7123 14.4381 14.4642 14.7523L6.53742 16.7478C5.51832 17.0043 4.87159 18.0058 5.05706 19.0402L5.98975 24.2421L7.60718 35.723C7.75995 36.8075 8.75647 37.5673 9.84267 37.4277L9.89094 37.4215Z"
        fill="url(#paint1_linear_217_1903)"
      />
      <path
        d="M17.3544 30.7844C17.3544 30.7844 11.5373 29.2865 13.1367 26.4128C14.0178 24.6484 16.0554 25.9364 16.0554 25.9364C16.0554 25.9364 17.4153 23.4324 19.2135 25.0902C21.3274 26.6633 17.3544 30.7844 17.3544 30.7844Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_217_1903"
          x1="11.8138"
          y1="0"
          x2="11.8138"
          y2="38"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF0031" />
          <stop offset="1" stopColor="#6E081C" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_217_1903"
          x1="16.7794"
          y1="3.88403"
          x2="16.7794"
          y2="37.4442"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF0031" />
          <stop offset="1" stopColor="#6E081C" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const BrandSkdjSymbol: React.FunctionComponent = () => {
  return (
    <div className="from-sk-yellow-200 to-sk-yellow-300 border-sk-yellow-500 mr-3 flex h-16 w-16 items-center justify-center rounded-full border-2 bg-linear-to-r">
      <BrandSymbol />
    </div>
  );
};
